import { Component, OnDestroy, OnInit } from '@angular/core';
import { Station } from './station.model';
import { Subscription } from 'rxjs';
import { MatchGameService } from './matchGameService.service';
import { GamePlayService } from '../game-play/gamePlayService.service';
import { ActivatedRoute } from '@angular/router';
import { TriviaGameService } from '../trivia-game/triviaGameService.service';
import { TimerService } from '../timer/timerService.service';
import { routeService } from '../route-service.service';
import { AudioServiceService } from '../audio-service.service';

@Component({
  selector: 'app-match-game',
  templateUrl: './match-game.component.html',
  styleUrls: ['./match-game.component.scss']
})
export class MatchGameComponent implements OnInit, OnDestroy {

  version: string;
  // game = {
  //   name: 'match-',
  //   info: " התחנות לסיבוב אחד. גלגלי ההצלה מתחדשים בכל שלב הבאים: צפייה במפה למספר שניות או לקבל את צבעי המסלול, השחקן יכול להיעזר בגלגלי ההצלה על ידי מענה מהיר של התחנות במפה. בכל שלב יש לשחקן שלוש פסילות. גג/'ג/'ג/'ג/'מג/ך'קיק/ךלח/'יק /'ק ךל/'קח ך/'לק ח/'ק /קךלקח/'ךקלח   קךל/'חק",
  //   kind: "match"
  // }
  game;
  lanes = [];
  level: number;
  gameInfoOpen = true;
  colorHelper = true;
  mapHelper = true;
  mapHelperCounter = false;
  didYouKnow = false;
  // slide = false;
  currentStation: Station;
  currentStations: Station[];
  totalStations: Station[] = [];
  levelSub: Subscription;
  currentStationsSub: Subscription;
  totalStationsSub: Subscription;
  start = true;
  // stationDidU = false;
  moving = null;

  constructor(private audioService: AudioServiceService, public routeService: routeService, private timerService: TimerService, private route: ActivatedRoute, private matchGameService: MatchGameService, public gamePlayService: GamePlayService, private triviaGameService: TriviaGameService) { }

  ngOnInit(): void {
    // this.gamePlayService.chooseGame.pause();
    // this.gamePlayService.matchGame.play();
    this.game = this.gamePlayService.game;

    // if (this.routeService.previousUrl == '/choose') {
    // this.slide = true;
    // let chooseGame = document.getElementById('chooseGame');
    // if (chooseGame) {
    //   chooseGame.classList.add('slide-in');
    //   setTimeout(() => {
    //     chooseGame.style.visibility = 'hidden';
    //   }, 1200);
    // }
    // }
    this.matchGameService.didYouKnow.subscribe(didU => {
      this.didYouKnow = didU;
      if (didU && this.currentStation.didYouKnow) {
        this.audioService.playAudio('popUp');
        this.timerService.pauseTimer();
      }
    });
    this.currentStationsSub = this.matchGameService.currentStations.subscribe(stations => {
      this.currentStations = stations;
    });
    this.totalStationsSub = this.matchGameService.totalStations.subscribe(stations => {
      this.totalStations = [];
      setTimeout(() => {
        this.totalStations = stations;
      }, 100);
      this.lanes = this.matchGameService.lanes;
    });
    this.levelSub = this.gamePlayService.level.subscribe(level => {
      let level_el = document.getElementById('level');
      if (level_el) {
        level_el.classList.remove('flip-level');
        setTimeout(() => {
          level_el.classList.add('flip-level');
        }, 100);
        setTimeout(() => {
          level_el.classList.remove('flip-level');
        }, 1000);
      }
      this.start = true;
      this.level = level;
      this.mapHelper = true;
      this.colorHelper = true;
    });
    // this.version = this.route.snapshot.params['id'];
    // if (this.version == 'mitanim' || this.version == 'nosaim') {
    //   this.game.name += this.version;
    // } else {
    //   this.game.name += 'mitanim';
    // }
  }

  finishLoop(trainLottie) {
    trainLottie.stop();
    setTimeout(() => {
      trainLottie.play();
    }, 5000);
  }

  newStations() {
    if (this.start) {
      this.audioService.playAudio('newStations');
      let time = ((this.totalStations.length * 0.05) + 0.7) * 1000;
      console.log(time);

      setTimeout(() => {
        this.audioService.stopAudio('newStations');
      }, time);
    }
  }

  nextLvl() {

    this.matchGameService.stationsArray = [];
    if (this.gamePlayService.level.getValue() < 6) {
      setTimeout(() => {
        this.gamePlayService.level.next(this.gamePlayService.level.getValue() + 1);
        this.matchGameService.newLevel();
      }, 100);
    } else {
      this.matchGameService.gameOver();
    }

  }

  tpick(event, index) {
    let clientX = event.clientX ? event.clientX : event.changedTouches[0].clientX;
    let clientY = event.clientY ? event.clientY : event.changedTouches[0].clientY;

    this.moving = event.target;
    if (this.moving.nodeName == 'H5') {
      this.moving = this.moving.parentElement;
    }
    let parent = this.moving.parentElement;
    parent.classList.remove('station-scale');
    this.start = false;

    this.moving.style.height = this.moving.clientHeight + 'px';
    this.moving.style.width = this.moving.clientWidth + 'px';
    this.moving.style.position = 'fixed';
    this.moving.style.left = (clientX - this.moving.clientWidth / 2) + 'px';
    this.moving.style.top = (clientY - this.moving.clientHeight / 2) + 'px';
  }

  tmove(event) {
    if (this.moving) {
      if (event.clientX) {
        // mousemove
        this.moving.style.left = (event.clientX - this.moving.clientWidth / 2) + 'px';
        this.moving.style.top = (event.clientY - this.moving.clientHeight / 2) + 'px';
      } else {
        // touchmove - assuming a single touchpoint
        this.moving.style.left = (event.changedTouches[0].clientX - this.moving.clientWidth / 2) + 'px';
        this.moving.style.top = (event.changedTouches[0].clientY - this.moving.clientHeight / 2) + 'px';
      }
    }
  }

  // drop(ev) {
  //   ev.preventDefault();
  //   var containerId = ev.target.id;
  //   var stationId = ev.dataTransfer.getData("text");

  //   if (stationId == containerId) {
  //     this.currentStation = this.matchGameService.stationsArray.find(station => station.name == stationId);  
  //     document.getElementById(containerId).style.display = "none";
  //     this.matchGameService.rightAnswer(stationId);
  //   } else {
  //     this.matchGameService.wrongAnswer();
  //   }
  // }
  tdrop(event) {
    let pageX = event.pageX ? event.pageX : event.changedTouches.item(0).pageX;
    let pageY = event.pageY ? event.pageY : event.changedTouches.item(0).pageY;
    this.moving.style.zIndex = '-1';
    var container_el: any = document.elementFromPoint(pageX, pageY);

    console.log(container_el == this.moving);

    if (container_el.id == this.moving.id && container_el != this.moving) {
      this.currentStation = this.matchGameService.stationsArray.find(station => station.name == this.moving.id);

      // if (this.currentStation.didYouKnow) {
      //   this.stationDidU = true;
      // } else {
      //   this, this.stationDidU = false;
      // }

      // document.getElementById(this.moving.id).style.display = "none";
      // document.getElementById(this.moving.id).classList.remove('station');
      document.getElementById(this.moving.id).classList.add('found-station');

      this.matchGameService.rightAnswer(this.moving.id);
      this.audioService.playAudio('correctTrivia');
    } else {
      this.moving.style.left = '';
      this.moving.style.top = '';
      this.moving.style.position = 'unset';
      this.moving.style.zIndex = 'unset';
      this.moving = null;
      // this.matchGameService.wrongAnswer();

      ////// להוציא מההערה כשיהיו תחנות ולהעיף את הWRONGANSWER מלמעלה

      if (container_el.classList.contains('match-game-station')) {
        this.audioService.playAudio('incorrect');
        this.matchGameService.wrongAnswer();
      }
    }
  }

  closeInfo() {
    this.gameInfoOpen = false;
  }

  onHelp(help) {
    switch (help) {
      case "color":
        this.colorHelper = false;
        let names = [];
        this.totalStations.forEach(station => {
          let found = false;
          this.currentStations.forEach(current => {
            if (station.name == current.name) {
              found = true;
              return;
            }
          });
          if (!found) {
            names.push(station.name);
          }
        });
        this.totalStations = this.totalStations.filter(station => !names.includes(station.name));
        break;
      case "map":
        this.mapHelper = false;
        this.mapHelperCounter = true;
        setTimeout(() => {
          let map = document.getElementById('mapCont');
          let backdrop = document.getElementById('backdrop');
          map.classList.remove('scale-in-pop');
          backdrop.classList.remove('go-in');
          map.classList.add('scale-out-pop');
          backdrop.classList.add('go-out');
          setTimeout(() => {
            this.mapHelperCounter = false;
          }, 700);
        }, 2500);
        break;
      default:
        break;
    }
  }

  onCloseDidYouKnow(el) {
    let backdrop = document.getElementById('backdrop');
    backdrop.classList.remove('go-in');
    backdrop.classList.add('go-out');
    // el.style.animation = 'scale-out-pop 0.7s forwards';
    el.classList.remove('scale-in-pop');
    el.classList.add('scale-out-pop');
    this.matchGameService.didYouKnowCounter = 0;
    setTimeout(() => {
      this.matchGameService.didYouKnow.next(false);
      this.timerService.resetScoreTimer();
      this.timerService.startTimer();
    }, 700);
  }

  ngOnDestroy() {
    this.currentStationsSub.unsubscribe();
    this.totalStationsSub.unsubscribe();
    this.levelSub.unsubscribe();
    // this.gamePlayService.matchGame.pause();
  }

}
